import React from 'react';
import PropTypes from 'prop-types';
import { getColor } from 'core/utils/Styles';

const Bar = ({
	width = 10,
	fill = getColor('malachite'),
	...props
}) => (
	<svg viewBox="0 0 100 5" preserveAspectRatio="none" {...props}>
		<title>Password Strength Bar</title>
		<rect x="0" width="100" height="5" fill={getColor('geyser')} />
		<rect x="0" width={width} height="5" fill={fill} />
	</svg>
);

Bar.propTypes = {
	width: PropTypes.number,
	fill: PropTypes.string,
};

export default Bar;
